import { Link } from 'react-router-dom'
import { Download, Plus } from 'lucide-react'
import { useUsers } from '@/modules/users/hooks/useUsers'
import { useUserMutation } from '@/modules/users/hooks/useUserMutation'
import { UsersTable } from '@/modules/users/components/UsersTable'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'
import { exportToExcel } from '@/shared/utils/exportToExcel'
import { useBranchOffices } from '@/modules/clients/hooks/useBranchOffices'

export function UsersListPage() {
  const { data, total, isLoading, error, filters, setPage, setLimit, applyFilters, clearSearch, refetch } =
    useUsers()
  const { remove } = useUserMutation()
  const { branches } = useBranchOffices()

  // Build branch name lookup map
  const branchNames: Record<number, string> = {}
  for (const branch of branches) {
    branchNames[branch.id] = branch.address
  }

  const handleExport = () => {
    exportToExcel(data, 'vendedores', [
      { key: 'id', label: 'ID' },
      { key: 'name', label: 'Nombre' },
      { key: 'last_name', label: 'Apellido' },
      { key: 'rut', label: 'RUT' },
      { key: 'email', label: 'Email' },
    ])
  }

  const handleDelete = async (id: number) => {
    await remove(id)
    refetch()
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Vendedores</h1>
        <div className="flex gap-2">
          <button onClick={handleExport} className="btn btn-secondary flex items-center gap-1.5">
            <Download size={16} />
            Exportar
          </button>
          <Link to="/users/new" className="btn btn-primary flex items-center gap-1.5">
            <Plus size={16} />
            Nuevo Vendedor
          </Link>
        </div>
      </div>

      {error && <ErrorState message={error} onRetry={refetch} />}

      <div className="card">
        <UsersTable
          data={data}
          total={total}
          page={filters.page}
          limit={filters.limit}
          filters={filters}
          onPageChange={setPage}
          onLimitChange={setLimit}
          onApplyFilters={applyFilters}
          onClearFilters={clearSearch}
          onDelete={handleDelete}
          isLoading={isLoading}
          branchNames={branchNames}
        />
      </div>
    </div>
  )
}
